import {Field, Label, Switch} from "@headlessui/react";
import React from "react";
import {useDarkMode} from "../../contexts/darkModeContext";
import {ArrowRightIcon} from "@heroicons/react/24/outline";
import UMIcons from "../Widgets/UMIcons";
import {UMMapping} from "../GLOBAL/GlobalFunctions";

const ContractPrice = ({ index, product }) => {
    
    const { darkMode } = useDarkMode();

    return (
        <div className={`grid grid-cols-7 p-3 border ${darkMode ? 'border-neutral-700' : ''} rounded-lg`}>
            
            {/*PRODUCT NAME*/}
            <div className="flex flex-col mt-auto mb-auto col-span-4">
                {/*Scrollable Name by Hover*/}
                <div ref={(container) => {
                    if (container) {
                        const textElement = container.querySelector('.scrollable-text');
                        if (textElement) {
                            container.classList.toggle(
                                'hover-enabled',
                                textElement.scrollWidth > container.offsetWidth
                            );
                        }
                    }
                }}
                     className={`relative overflow-hidden ${
                         darkMode ? 'text-white' : 'text-black'
                     } text-sm font-medium w-full`}
                >
                    <div
                        className="scrollable-text inline-block whitespace-nowrap transition-transform duration-1000 ease-linear"
                        style={{
                            transform: 'translateX(0)',
                        }}
                        onMouseEnter={(e) => {
                            const container = e.currentTarget.parentElement;
                            if (container.classList.contains('hover-enabled')) {
                                e.currentTarget.style.transform = 'translateX(-50%)';
                            }
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateX(0)';
                        }}
                    >
                        {product.name}
                    </div>
                </div>
                <div
                    className={`ml-3 text-xxs ${darkMode ? 'text-borderColor' : 'text-borderColor'}`}>{product.productCode}</div>
            </div>
            
            {/*Percent Toggle*/}
            <Field className="flex flex-col items-center col-span-2">
                <Switch
                    checked={product.percent}
                    // onChange={setPercent}
                    className="group relative inline-flex h-5 w-10 shrink-0 cursor-pointer items-center justify-center rounded-full bg-transparent"
                >
                    <span className="sr-only">Use setting</span>
                    <span aria-hidden="true"
                          className="pointer-events-none absolute size-full rounded-md"/>
                    <span
                        aria-hidden="true"
                        className={`pointer-events-none absolute mx-auto h-4 w-9 rounded-full ${darkMode ? 'bg-neutral-700' : 'bg-gray-200'} transition-colors duration-200 ease-in-out group-data-[checked]:bg-green-600`}
                    />
                    <span
                        aria-hidden="true"
                        className="pointer-events-none absolute left-0 inline-block size-5 transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out group-data-[checked]:translate-x-5"
                    />
                </Switch>
                <Label as="span" className="mt-1 text-xxs">
                    
                    {product.percent ? (
                        <span className="font-medium line-clamp-1">Percentage Off</span>
                    ) : (
                        <span className="font-medium line-clamp-1">Custom Price</span>
                    )}
                
                </Label>
            </Field>
            
            {/*ICONS*/}
            <Field className="flex flex-col items-center col-span-1">
                <UMIcons selectedVolume={product.selectedVolume}/>
            </Field>
            
            {/*PRICE*/}
            <div className={`relative col-span-2 p-1.5`}>
                <div
                    className={`${darkMode ? 'bg-darkBgColor' : 'border bg-neutral-50'} relative flex flex-row px-2 rounded-lg h-full items-center justify-center`}>
                    <div className="text-borderColor text-md mr-1">$</div>
                    <div
                        className={`${darkMode ? 'text-white' : 'text-black'} rounded-md text-sm p-1.5 w-full tracking-wider line-clamp-1`}>{parseFloat(product.price).toFixed(2)}</div>
                    <div className="text-borderColor text-xs">USD</div>
                </div>
            </div>
            
            {/*Arrow*/}
            <div className="flex flex-row px-1 h-full items-center justify-center">
                <ArrowRightIcon
                    className={`text-borderColor w-4 stroke-2`}/>
            </div>
            
            {/*New Price*/}
            <div className={`relative col-span-2 p-1.5`}>
                <div className={`${darkMode ? 'bg-darkBgColor' : 'border bg-neutral-50'} flex flex-row px-2 rounded-lg h-full items-center justify-center hover:scale-y-105`}>
                    
                    <div className={`text-borderColor text-md mr-1 ${product.percent ? 'hidden' : ''}`}>$</div>
                    <div className={`${darkMode ? 'text-white' : 'text-black'} rounded-md text-sm p-1.5 w-full tracking-wider line-clamp-1`}>
                        {parseFloat(product.newValue).toFixed(2)}
                    </div>
                    <div className="text-borderColor text-xs">{product.percent ? '%' : 'USD'}</div>
                    
                </div>
            </div>
            
            {/*U/M*/}
            <div className={`relative col-span-2 p-1.5`}>
                <div
                    className={`${darkMode ? 'bg-darkBgColor' : 'border bg-neutral-50'} line-clamp-1 overflow-x-hidden flex flex-row text-xs rounded-lg h-full items-center justify-center hover:scale-y-105`}>
                    {UMMapping[product.selectedVolume]}
                </div>
            </div>
            
        </div>
    )
}

export default ContractPrice;
